import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FacFinderService } from '../fac-finder.service';
import { XFacContactAddModel } from 'src/app/shared/models/xfac-contact.model';
import { XFacContactResponse, XFacAddressResponse, XFacEmploymentResponse, XFacGoalResponse, XFacIncomeResponse } from 'src/app/shared/models/response.model';
import { XFacAddressAddModel } from 'src/app/shared/models/xfac-address.model';
import { XFacEmploymentAddModel } from 'src/app/shared/models/xfac-employment.model';
import { XFacGoalAddModel } from 'src/app/shared/models/xfac-goal.model';
import { XFacIncomeAddModel } from 'src/app/shared/models/xfac-income.model';

@Component({
  selector: 'app-add-income',
  templateUrl: './add-income.component.html',
  styleUrls: ['./add-income.component.css']
})
export class AddIncomeComponent implements OnInit {

  data;
  addIncomeForm: FormGroup;
  incomeAddModel : XFacIncomeAddModel;
  submitted = false;
  event: EventEmitter<any> = new EventEmitter();
  Isvalid:boolean;
  business_id : string;
  buttonText: string ="Add New Contact Details";
  facFinderId : any;
  clientCode : any;
  incomeCashflowList : any = [];
  incomeCashflowSubtypeList : any = [];
  incomeExpenseCashflowOwnerList : any = [];
  incomeExpenseCashflowFrequencyList : any = [];
  title: any;

  constructor(
    private ngxService: NgxUiLoaderService,
    private formBuilder: FormBuilder,
    private router: Router, 
    private facFinderService: FacFinderService,
    public modalRef: BsModalRef,
    private toastr: ToastrService
    ) { }
 
  ngOnInit() {
    this.Isvalid = true;    
    this.incomeAddModel = new XFacIncomeAddModel(); 
    this.incomeAddModel.type ="000"; 
    this.incomeAddModel.typeGroup ="000"; 
    this.incomeAddModel.ownerType ="000"; 
    this.incomeAddModel.frequency = -99; 

    if(this.data.income !=null){
      //console.log(this.data.library);
      this.buttonText = "Update Now";
      Object.assign(this.incomeAddModel, this.data.income);
    }

    if(this.data.income_cashflow_list !=null){
      Object.assign(this.incomeCashflowList, this.data.income_cashflow_list);
    }

    if(this.data.income_cashflow_subtype_list !=null){
      Object.assign(this.incomeCashflowSubtypeList, this.data.income_cashflow_subtype_list);
    }

    if(this.data.income_expense_cashflow_owner_list !=null){
      Object.assign(this.incomeExpenseCashflowOwnerList, this.data.income_expense_cashflow_owner_list);
    }

    if(this.data.income_expense_cashflow_frequency_list !=null){
      Object.assign(this.incomeExpenseCashflowFrequencyList, this.data.income_expense_cashflow_frequency_list);
    }

    if(this.data.facFinderId !=null){
      this.facFinderId = this.data.facFinderId;
    }

    if(this.data.clientCode !=null){
      this.clientCode = this.data.clientCode;
    }

    this.title = this.data.title;

    // console.log(this.clientCode);
    // if(this.data.business_id !=null){
    //   this.business_id = this.data.business_id;
    // }

    this.addIncomeForm = this.formBuilder.group({ 
      type: ['', Validators.required],
      typeGroup: ['', Validators.required],
      description: ['', Validators.required],
      ownerType: ['', Validators.required],
      frequency: ['', Validators.required],
      amountValue: ['', Validators.required],
    });

  }

  get f() { return this.addIncomeForm.controls; }

onSubmit(){
 this.submitted = true;

 let typeGroup = this.incomeAddModel.typeGroup;
 let ownerType = this.incomeAddModel.ownerType;
 let frequency = this.incomeAddModel.frequency;
 let type = this.incomeAddModel.type;

 if (this.addIncomeForm.invalid || (typeGroup && typeGroup.trim()=="000") || (type && type.trim()=="000") || (ownerType && ownerType.trim()=="000") || (frequency && frequency==-99) ) { //|| (title && title.trim()=="")
  if(typeGroup && typeGroup.trim()=="000"){
    this.addIncomeForm.controls['typeGroup'].setErrors({'required': true});
  }

  if(ownerType && ownerType.trim()=="000"){
    this.addIncomeForm.controls['ownerType'].setErrors({'required': true});
  }
  if(type && type.trim()=="000"){
    this.addIncomeForm.controls['type'].setErrors({'required': true});
  }

  if(frequency && frequency==-99){
    this.addIncomeForm.controls['frequency'].setErrors({'required': true});
  }

  console.log(this.f);
  console.log(this.addIncomeForm.invalid);
  return;
}

else{
  //this.folderModel.name = title.trim();
  this.incomeAddModel.amountCode = 'AUD';

  if(this.data.income !=null){
  //   this.ngxService.start();
  // //console.log("Edditre");

    this.ngxService.start();
    this.incomeAddModel.clientCode = this.clientCode;
    this.facFinderService.editIncome(this.incomeAddModel, this.facFinderId)
    .subscribe((data:XFacIncomeResponse)=>{
    this.ngxService.stop();
    if(data.error && !data.success){      
      this.toastr.error('Error on updating income.');      
    }
    else{
      this.toastr.success('Income updated successfully.');
      this.event.emit('OK');
    // console.log(this.event);
      this.modalRef.hide();
    }
    
    },err=>{   
      console.log(err);
      this.ngxService.stop();
      this.toastr.error('Error on updating income.');
    });
      
    //this.router.navigate(['agents']);    

  }else{
    
    this.ngxService.start();
    this.incomeAddModel.clientCode = this.clientCode;
    this.facFinderService.addIncome(this.incomeAddModel, this.facFinderId)
    .subscribe((data:XFacIncomeResponse)=>{
    this.ngxService.stop();
    if(data.error && !data.success){      
      this.toastr.error('Error on saving income.');      
    }
    else{
      this.toastr.success('Income added successfully.');
      this.event.emit('OK');
     // console.log(this.event);
      this.modalRef.hide();
    }
    
    },err=>{   
      console.log(err);
      this.ngxService.stop();
      this.toastr.error('Error on saving income.');
    });

  }

}

}

  modalRehide(){
    if (!this.modalRef) {
      return;
    } 
    this.modalRef.hide();
    this.modalRef = null;
  }

  ClosePopup(){
    this.modalRef.hide();
  }

  onReset() {
    this.submitted = false;
    this.addIncomeForm.reset();
  }

  onChange(value){
    let subtypeList = [];
    // console.log(value);
    this.data.income_cashflow_subtype_list.forEach(device => {
      if(device.key.indexOf(value)==0){
        subtypeList.push(device);
      }
    })

    this.incomeCashflowSubtypeList = subtypeList;//this.data.asset_sub_type.filter(device => device.key === value);
    //this.incomeAddModel.type ="000"; 

    let choice = this.incomeCashflowSubtypeList.filter(choice => choice.key == this.incomeAddModel.type);
    if(choice && choice[0]) {
      this.incomeAddModel.type = choice[0].key;
      // this.selectedChoice = choice[0].key;
    }
    else{
      this.incomeAddModel.type = "000";
    }
    
    // console.log(this.incomeCashflowSubtypeList);
  }

}
